import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  // Mostrar el botón cuando se baja más de 300px
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Función para volver al inicio
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {visible && (
        <button
          onClick={scrollToTop}
          className="btn btn-primary rounded-circle shadow"
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            width: "50px",
            height: "50px",
            fontSize: "22px",
            backgroundColor: "#B91667",
            border:"#B91667",
            zIndex: "1000",
          }}
          aria-label="Subir"
        >
          ↑
        </button>
      )}
    </>
  );
};

export default ScrollToTopButton;
